import FlowLayoutViewModelT from '@/ViewModels/Controls/FlowLayoutViewModel';
import AsyncLayoutFactory from '@/Factories/AsyncLayoutFactory';
import ComponentManager from '@/Management/ComponentManager';
import FlowLayout from '@/Controls/FlowLayout';
import { ILayoutFactoryConstructorParameter } from '#/CoreFrameInterfaces';

interface IFlowLayoutFactoryParams extends ILayoutFactoryConstructorParameter {
    mode?: string;
    orientation?: string;
    alignment?: string;
}

export default class FlowLayoutFactory extends AsyncLayoutFactory {
    public mode: string;
    public orientation: string;
    public alignment: string;
    public viewModel: FlowLayoutViewModelT;
    private jQueryControl: JQuery;
    private control: FlowLayout;
    private FlowLayoutViewModel = ComponentManager.getViewModel<typeof FlowLayoutViewModelT>('FlowLayoutViewModel');
    private FlowLayout = ComponentManager.getControl<typeof FlowLayout>('FlowLayout');

    constructor(params: IFlowLayoutFactoryParams) {
        super(params);

        this.mode = this.paramOrDefault(params.mode, 'Default');
        this.orientation = this.paramOrDefault(params.orientation, 'Horizontal');
        this.alignment = this.paramOrDefault(params.alignment, 'None');
    }

    public async getElementAsync(): Promise<JQuery> {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.viewModel = new this.FlowLayoutViewModel({
            mode: this.mode,
            orientation: this.orientation,
            alignment: this.alignment,
            tuples: this.tuples,
            labelColumnWidth: this.context.labelColumnWidth
        });
        this.control = new this.FlowLayout(this.viewModel);
        const tuple = await this.control.getTupleAsync();
        this.jQueryControl = tuple.control;
        return this.jQueryControl;
    }
}

ComponentManager.setFactory('FlowLayout', FlowLayoutFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');